import styled from 'styled-components';

export const ChatHeaderContainer = styled.div`
  width: 100%;
  height: auto;
  min-height: 65px;
  background: ${(props) => props.theme.colors?.greys?.lightest};
  padding: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  border-bottom: 1px solid ${(props) => props.theme.colors?.greys?.light};
`;
